import { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { Button, Col } from 'reactstrap';

import { sanitizeMailboxHtml } from '../../../helpers';

const ComposeOriginalMessage = ({
    t,
    original,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const html = original?.html || '';
    const text = original?.text || '';
    const hasBody = Boolean(html || text);
    const hasMeta = Boolean(original?.from || original?.date || original?.to || original?.subject);

    if (!original || (!hasBody && !hasMeta)) {
        return null;
    }

    return (
        <Col sm="12" className="mailbox-reply-original">
            <Button
                type="button"
                color="link"
                className="mailbox-reply-original__toggle"
                aria-expanded={isOpen}
                title={isOpen ? t('Hide original message') : t('Show original message')}
                onClick={() => setIsOpen((current) => !current)}
            >
                <i className="mdi mdi-dots-horizontal" />
            </Button>
       

            {isOpen ? (
                <div className="mailbox-reply-original__panel">
                    <div className="mailbox-reply-original__meta">
                        {original.from ? (
                            <div>
                                <span>{t('From')}:</span>
                                {' '}
                                {original.from}
                            </div>
                        ) : null}
                        {original.date ? (
                            <div>
                                <span>{t('Sent')}:</span>
                                {' '}
                                {original.date}
                            </div>
                        ) : null}
                        {original.to ? (
                            <div>
                                <span>{t('To')}:</span>
                                {' '}
                                {original.to}
                            </div>
                        ) : null}
                        {original.subject ? (
                            <div>
                                <span>{t('Subject')}:</span>
                                {' '}
                                {original.subject}
                            </div>
                        ) : null}
                    </div>
                    {html ? (
                        <blockquote
                            className="mailbox-reply-original__body mailbox-message-body"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeMailboxHtml(html),
                            }}
                        />
                    ) : (
                        <blockquote className="mailbox-reply-original__body">
                            {text}
                        </blockquote>
                    )}
                </div>
            ) : null}
        </Col>
    );
};

export default withNamespaces()(ComposeOriginalMessage);
